<script>
import { mapGetters } from 'vuex'

export default {
    name: "referenciaProfesionalPostulacion",
    data(){
        return {
            baseReferencias: {
                nombresYApellidos: null,
                ocupacion: null,
                telefono: null,
                direccion: null,
                paisId: null,
                departamentoId: null,
                municipioId: null,
            },
            departamentos: [],
            municipios: []

        }
    },
    mounted() {
        if( !this.$store.getters.resumenReferencias.length ) {
            this.agregarRegistro()
        }
    },
    computed: {
        ...mapGetters({
            listaPaises: 'getPaises',
            listaDepartamentos: 'getDepartamentos',
            listaMunicipios: 'getMunicipios',
            resumenReferencias: 'resumenReferencias'
        })
    },
    methods: {
        assertData(idx) {
            console.log(this.$store.getters.resumenReferencias[idx]);
        },
        agregarRegistro() {
            this.$store.commit('appendElement', { key: 'resumenReferencias', newElement: this.baseReferencias} )
        },
        eliminarRegistro(idx) {
            this.departamentos.splice(idx, 1)
            this.municipios.splice(idx, 1)
            this.$store.commit('deleteElementAt', { key: 'resumenReferencias', idx})
        },
        saveAndContinue() {
            const inputs = document.querySelectorAll('input, select')
            try {
                inputs.forEach(input => {
                    if (!input.checkValidity()) {
                        input.reportValidity()
                        throw new Error('Formulario incompleto')
                    }
                })
                
                
                let data = [
                    ...this.resumenReferencias.map( formacion => {
                        formacion.PostulacionId = this.$store.getters.postulacionId
                        return formacion
                    })
                ]


                this.$store.getters.fetchPost({ path: 'Postulacion/ReferenciaPersonal', data })
                .then( response => {
                    if( response.ok )
                    {
                        return response.json()
                    }
                    throw new Error("No se ha podido guardar educación formal")
                })
                .then( result => {
                    console.log(result);
                    this.$emit('endOfPostulacion')
                })
                .catch( error => console.log(error))


            } catch (error) {
                console.log(error);
                return
            }
        },
        setDepartamentosInElement( idx, paisId = null){
            this.$store.getters.fetchGet({ path: 'DepartamentoPais/ListByPais/' + paisId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.departamentos.length - 1) {
                        this.departamentos.push(data)
                    } else {
                        this.departamentos[idx] = data
                    }
                    this.departamentos = [...this.departamentos]
                })
                .catch(error => console.error(error))
        },
        setMunicipiosInElement( idx, departamentoId = null){
            this.$store.getters.fetchGet({ path: 'Municipio/ListByDepartamento/' + departamentoId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.municipios.length - 1) {
                        this.municipios.push(data)
                    } else {
                        this.municipios[idx] = data
                    }
                    this.municipios = [...this.municipios]
                })
                .catch(error => console.error(error))
        }
    }
}

</script>
<template>
    <div>
        <b-form @submit.prevent="assertData(idx)" v-for="(referencia, idx) in resumenReferencias" :key="'experiencia ' + idx">
            <b-row class="pb-1 px-3">
                <div class="d-flex align-items-center justify-content-between" style="width: 100%">
                    <p class="text-center my-0">
                        <b>
                            Ref. Referencia {{ idx + 1 }}
                        </b>
                    </p>
                    <div class="pointer btn btn-outline-danger m-1" @click="eliminarRegistro(idx)">
                        <i class="fas fa-solid fa-trash px-1"></i>Eliminar
                    </div>
                </div>
            </b-row>
            <b-row class="pb-2">
                <b-col sm>
                    <label for="referenciasNombresYApellidos" class="form-label">Nombres y apellidos</label>
                    <b-form-input v-model="referencia.nombresYApellidos" type="text" id="referenciasNombresYApellidos" required/>
                 </b-col>
                <b-col sm>
                    <label for="referenciasOcupacion" class="form-label">Ocupación</label>
                    <b-form-input v-model="referencia.ocupacion" type="text" id="referenciasOcupacion" required/>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="referenciasTelefono" class="form-label">Teléfono</label>
                    <b-form-input v-model="referencia.telefono" type="text" id="referenciasTelefono" required/>
                </b-col>
                <b-col sm>
                    <label for="referenciasDireccion" class="form-label">Dirección</label>
                    <b-form-input v-model="referencia.direccion" type="text" id="referenciasDireccion" required/>
               </b-col>
            </b-row>
            
            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNoFPais" class="form-label">País</label>
                    <b-form-select required v-model="referencia.paisId" text-field="descripcion" value-field="id"
                        :options="listaPaises"
                        @change.native="setDepartamentosInElement( idx, referencia.paisId)"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm>
                    <label for="educacionNoFDepartamento" class="form-label">Departamento</label>
                    <b-form-select required v-model="referencia.departamentoId" text-field="descripcion" value-field="id"
                        :options="departamentos[idx]"
                        @change.native="setMunicipiosInElement( idx, referencia.departamentoId)"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionNoFMunicipio" class="form-label">Municipio</label>
                    <b-form-select required v-model="referencia.municipioId" text-field="descripcion" value-field="id"
                        :options="municipios[idx]"
                        
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm></b-col>
            </b-row>

        </b-form>
        <div class="d-flex flex-row-reverse py-2" style="width: 100%; gap: 5px">
            <button class="btn px-4 py-2 btn-primary" @click="saveAndContinue">
                <span> Finalizar </span>
            </button>
            <button class="btn px-4 py-2 btn-outline-success" @click="agregarRegistro">
                <span> Nuevo registro </span>
            </button>
        </div>
    </div>
</template>
